import styled from "styled-components"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import { Article } from "gatsby-theme-blank/src/components/ResultsTaxo/ResultItem/result-item-styled"

const ColoredIcon = styled(Icon)`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const Type = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
  & ~ h4,
  & ~ p {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

export { Article, Type, ColoredIcon }
